import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EquipamentoService } from 'src/app/services/equipamento.service';
import { SimpleChanges, LOCALE_ID } from '@angular/core';
import { OnChanges } from '@angular/core';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-detalhes-equipamento',
  templateUrl: './detalhes-equipamento.component.html',
  styleUrls: ['./detalhes-equipamento.component.scss']
})
export class DetalhesEquipamentoComponent implements OnInit, OnChanges {

  constructor(
    private equipamentoService: EquipamentoService,
    private modalService: NgbModal
  ) { }

  @Input() public shouldOpenModal: boolean;
  @Input() public equipamentoId: number;
  @ViewChild('modal') modal: ElementRef;

  equipamento: any;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.shouldOpenModal != null) {
      
      if (changes.shouldOpenModal) {
        setTimeout(() => {

          if (this.equipamento != undefined) {

            if (this.equipamento.id != this.equipamentoId) {
              this.getEquipamento();
            } else {
              this.openModal();
            }

          } else {
            this.getEquipamento();
          }
        });
      }
    }
  }

  getEquipamento()
  {
    this.equipamentoService.getById(this.equipamentoId).subscribe((response) => {
      this.equipamento = response;
      this.openModal();
    })
  }


  openModal() {
    this.modalService.open(this.modal, { windowClass: 'xlModal' });
  }


}
